// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1264px){.project-media-carousel[data-v-04792591]  .swiper-nav-button{position:absolute;top:-32px;z-index:2}.project-media-carousel[data-v-04792591]  .swiper-nav-button.sanity-media-swiper-button-prev{right:8px;transform:translate(-100%,-100%)}.project-media-carousel[data-v-04792591]  .swiper-nav-button.sanity-media-swiper-button-next{right:0;transform:translateY(-100%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
